import { navbarHeight } from './variables.js';

(($) => {
  $(() => {
    const $scrollable = $('html, body');

    $(document).on('click', 'a[href^="#"]:not([data-bs-toggle])', (e) => {
      const $a = $(e.currentTarget);
      const selector = $a.attr('href');

      if (!/^#(master$|mm-)/.test(selector) && selector !== '#') {
        const $target = $(selector);

        if ($target.length) {
          e.preventDefault();

          $scrollable.animate(
            {
              scrollTop: $target.offset().top - navbarHeight,
            },
            400
          );
        }
      }
    });
  });
})(jQuery);
